<mat-card class="cardWithShadow">
    <mat-card-content class="p-24"> 
  
        <div class="table-responsive" [hidden]="dataSource?.data.length == 0">
          <table
            mat-table
            [dataSource]="dataSource"
            class="w-100"
            matSort
            matSortDirection="asc"
          >
  
            <ng-container matColumnDef="clientName">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="th-title"
              >
                Nombre
              </th>
              <td mat-cell *matCellDef="let element">
                <span>
                    {{ element.clientName }}
                </span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="clientRut">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="th-title"
              >
              Rut
              </th>
              <td mat-cell *matCellDef="let element">
                <span>
                    {{ element.clientRut }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="totalAmount">
                <th
                  mat-header-cell
                  mat-sort-header
                  *matHeaderCellDef
                  class="th-title"
                >
                Monto
                </th>
                <td mat-cell *matCellDef="let element">
                  <span>
                      {{ element.totalAmount | currency: 'CLP' }}
                  </span>
                </td>
              </ng-container>
    
            <ng-container matColumnDef="numberInvoice">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="th-title"
              >
                N° Documentos
              </th>
              <td mat-cell *matCellDef="let element" class="mat-body-1">
                <span>
                    {{ element.numberInvoice }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="fechaDocto">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="th-title"
                >
                  Fecha Documento
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                  <span>
                    {{ element.fechaDocto | date : "dd/MM/yyyy" }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="isCedible">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="th-title"
                >
                Cedible
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                    <span *ngIf="element.isCedible">
                        <fa-icon style="color: green;" [icon]="icons.faCircleCheck"></fa-icon>
                    </span>
                    <span *ngIf="!element.isCedible">
                        <fa-icon style="color: red;" [icon]="icons.faCircleXmark"></fa-icon>
                    </span>
                </td>
              </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    
          </table>
          <mat-paginator [pageSizeOptions]="[5, 10, 20, 100]"></mat-paginator>
        </div>

        <div class="spinner">
            <mat-spinner [diameter]="50" *ngIf="booleanCargandoSellInvoces == true"></mat-spinner>
            <h3 *ngIf="booleanVentas == true && booleanCargandoSellInvoces == false">No hay Informacion</h3>
        </div>

    </mat-card-content>
  </mat-card>